<h2 class="h2">{{'Gift Box Service' | translate}}</h2>
@for (box of giftBoxing; track $index) {
<p class="lh-3 p-t-3 p-t-4-m p-t-4-s">{{box.gift_copy}}</p>
}
<!-- <div>{{ content.giftBoxingImage }}</div> -->
<div class="center p-t-3 p-t-8-m p-t-6-s p-b">
    <img class="w-6 w-7-m w-8-s"
         [dfImage]="content.gift_boxing_image"
         ratio="1">
</div>